import Vue from "vue";
import Vuex from "vuex";

import storeFunctions from '../../../../world/spa/libs/vuexFunctions';

/* Modules */
import config from "./modules/config";
import works from "./modules/works";
import paglieraniContactPricing from "./modules/paglieraniContactPricing";
import users from "./modules/users";
import projects from "./modules/projects";
import employments from "./modules/employments";
import events from "./modules/events";
import places from "./modules/places";
import contacts from "./modules/contacts";
import contactsStatus from "./modules/contactsStatus";
import contactsCompetitors from "./modules/contactsCompetitors";
import contactsLeadChannel from "./modules/contactsLeadChannel";
import contactsAbandoned from "./modules/contactsAbandoned";
import contactPlaceAssocs from './modules/contactPlaceAssocs';
import licenses from "./modules/licenses";
import messageChannels from './modules/messageChannels';
import messages from './modules/messages';
import tags from './modules/tags';
import pricings from './modules/pricings';
import workCosts from './modules/workCosts';
import outgoCategories from './modules/outgoCategories';
import outgoCategoryContactAssocs from './modules/outgoCategoryContactAssocs';
import bankAccounts from './modules/bankAccounts';
import workBankAccountAssocs from './modules/workBankAccountAssocs';
import feedBoardAssocs from './modules/feedBoardAssocs';
import files from './modules/files';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    ...storeFunctions.rootState,
    contactSelected: null
  },
  getters: {
    ...storeFunctions.rootGetters,
    getContactSelected: state => {
      return state.contactSelected;
    }
  },
  mutations: {
    ...storeFunctions.rootMutations,
    selectContact: (state, id) => {
      state.contactSelected = id;
    },
  },
  actions: {
    ...storeFunctions.rootActions,
    selectContact: ({ commit }, id) => {
      return new Promise(resolve => {
        commit('selectContact', id);
        resolve();
      })
    },
  },
  modules: {
    config,
    works,
    feedBoardAssocs,
    paglieraniContactPricing,
    users,
    projects,
    employments,
    events,
    places,
    contacts,
    contactsStatus,
    contactsAbandoned,
    contactsLeadChannel,
    contactsCompetitors,
    contactPlaceAssocs,
    licenses,
    messageChannels,
    messages,
    tags,
    pricings,
    workCosts,
    outgoCategories,
    outgoCategoryContactAssocs,
    bankAccounts,
    workBankAccountAssocs,
    files,
  }
});
